import { render, staticRenderFns } from "./issue-assistant-confirm.vue?vue&type=template&id=e3edc9f4"
import script from "./issue-assistant-confirm.vue?vue&type=script&lang=js"
export * from "./issue-assistant-confirm.vue?vue&type=script&lang=js"
import style0 from "./issue-assistant-confirm.vue?vue&type=style&index=0&id=e3edc9f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports